import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/profile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2a06f802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-moon" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-sun" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-2a06f802><div class=\"social\" data-v-2a06f802><a href=\"https://www.linkedin.com/in/matheus-de-sa/\" data-v-2a06f802><i class=\"bx bxl-linkedin\" data-v-2a06f802></i></a><a href=\"https://www.linkedin.com/in/matheus-de-sa/\" data-v-2a06f802><i class=\"bx bxl-instagram-alt\" data-v-2a06f802></i></a><a href=\"https://www.linkedin.com/in/matheus-de-sa/\" data-v-2a06f802><i class=\"bx bxl-github\" data-v-2a06f802></i></a></div><div class=\"header-left\" data-v-2a06f802><div class=\"profile\" data-v-2a06f802><div class=\"img\" data-v-2a06f802><img src=\"" + _imports_0 + "\" alt=\"\" data-v-2a06f802></div></div><h2 data-v-2a06f802>Olá, me chamo Matheus de Sá</h2></div></div>", 1)
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Sobre", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Sou apaixonado por tecnologia, me descobri na área do desenvolvimento e hoje não me vejo fazendo algo diferente, já realizei alguns projetos de sucesso que me orgulho bastante, meu foco é no desenvolvimento web completo. Trabalho principalmente com VueJs e NodeJs, tenho conhecimento e experiência com diversas linguagens e estou sempre buscando me aprimorar. Gosto de animais (principalmente cães e pássaros), conhecer lugares novos, estudar um pouco sobre tudo e principalmente amo o espaço. ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Tecnologias", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Estudando", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Projetos", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("VueSty")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Biblioteca de componentes e estilos para VueJs")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("TodoList")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Uma PWA criada com VueJs e Firebase")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Indicou")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Plataforma de indicações")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Gastos")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Sistema para gestão de gastos, criado com VueJs e Firebase")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Sistema de Follows")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Sistema para gestão de follows")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Projeto Programar")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Aulas de programação para jovens do ensino médio")
const _hoisted_24 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Project = _resolveComponent("Project")!
  const _component_BottomBar = _resolveComponent("BottomBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Switch, {
      id: "user",
      style: {"margin-top":"1rem"}
    }, {
      on: _withCtx(() => [
        _hoisted_2
      ]),
      off: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "body",
        onTouchmove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeRouteScroll('#user'))),
        onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeRouteScroll('#user'))),
        onWheelPassive: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeRouteScroll('#user')))
      }, _hoisted_8, 32),
      _createElementVNode("div", {
        id: "code",
        class: "body",
        onTouchmove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeRouteScroll('#code'))),
        onScrollPassive: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeRouteScroll('#code'))),
        onWheelPassive: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeRouteScroll('#code')))
      }, [
        _hoisted_9,
        _createVNode(_component_Select, { codes: [
                        'Vue',
                        'JavaScript',
                        'TypeScript',
                        'NodeJs',
                        'Html5',
                        'Css3',
                        'Sass',
                        'Sql',
                        'Firebase',
                        'MongoDB',
                    ] }),
        _hoisted_10,
        _createVNode(_component_Select, { codes: ['Flutter', 'Java', 'C#'] })
      ], 32),
      _createElementVNode("div", {
        id: "data",
        class: "body",
        onTouchmove: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeRouteScroll('#data'))),
        onScrollPassive: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeRouteScroll('#data'))),
        onWheelPassive: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeRouteScroll('#data')))
      }, [
        _hoisted_11,
        _createVNode(_component_Project, null, {
          title: _withCtx(() => [
            _hoisted_12
          ]),
          body: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_Project, {
          linkGit: "https://github.com/matheus-de-sa/ToDo-List",
          link: 'https://todolist-4ab9a.web.app'
        }, {
          title: _withCtx(() => [
            _hoisted_14
          ]),
          body: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["link"]),
        _createVNode(_component_Project, { link: 'https://indicou.me/' }, {
          title: _withCtx(() => [
            _hoisted_16
          ]),
          body: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["link"]),
        _createVNode(_component_Project, {
          linkGit: "https://github.com/matheus-de-sa/Gastos",
          link: 'https://vue-projeto-b8c20.web.app'
        }, {
          title: _withCtx(() => [
            _hoisted_18
          ]),
          body: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["link"]),
        _createVNode(_component_Project, { linkGit: "https://github.com/matheus-de-sa/Sistema-Follows" }, {
          title: _withCtx(() => [
            _hoisted_20
          ]),
          body: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_Project, {
          linkGit: "https://github.com/unisociesc/Projeto-Programar",
          link: 'https://www.youtube.com/channel/UCnNu9qNpYQY9zQCI-MGVdwQ'
        }, {
          title: _withCtx(() => [
            _hoisted_22
          ]),
          body: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        }, 8, ["link"])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createVNode(_component_BottomBar, { ref: "buttomBar" }, null, 512)
    ])
  ]))
}